module.exports = __webpack_public_path__ + "images/qrcode-guide.a76a290d.png";